import React from 'react';
import styled from 'styled-components';
import { Body5Medium } from 'styles/Global/typography';

interface WarningItemProps {
    text: string;
    isImportant?: boolean;
}

export const WarningItem: React.FC<WarningItemProps> = ({ text, isImportant = false }) => {
    return (
        <StyledWarningItem>
            <Body5Medium>-</Body5Medium>
            <div>
                <Body5Medium>{text}</Body5Medium>
            </div>
        </StyledWarningItem>
    );
};

const StyledWarningItem = styled.div`
    display: flex;
    gap: 4px;
`;
